module.exports = __webpack_public_path__ + "img/1.4791c483.png";